import Navbar from '../ui/Navbar'
import FooterInfo from '../ui/FooterInfo'

export const Layout = ({ children }: { children?: any }): JSX.Element => {
  return (
    <div className='flex flex-col w-full min-h-screen'>
      <header dir='ltr'>
        <Navbar />
      </header>
      <main className='flex-grow mt-12 space-y-7 w-full mx-auto px-4 sm:px-6'>
        {children}
      </main>
      <footer
        className='w-full text-white'
        style={{ backgroundColor: 'var(--footer-bg)' }}
      >
        <FooterInfo />
      </footer>
    </div>
  )
}
